import Swiper from 'swiper'
import { SwiperOptions } from 'swiper/types/swiper-options'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

const createNavigation = (carousel: HTMLElement) => {
    const navigation: HTMLElement = document.createElement('nav')
    navigation.classList.add('swiper-navigation')

    const buttonPrev: HTMLButtonElement = document.createElement('button')
    buttonPrev.classList.add('swiper-navigation__button', 'swiper-navigation__button-prev')
    buttonPrev.ariaLabel = `{{js.swiper.navigation.slide.previous.aria-label}}`

    const buttonNext: HTMLButtonElement = document.createElement('button')
    buttonNext.classList.add('swiper-navigation__button', 'swiper-navigation__button-next')
    buttonNext.ariaLabel = `{{js.swiper.navigation.slide.next.aria-label}}`

    navigation.appendChild(buttonPrev)
    navigation.appendChild(buttonNext)

    carousel.appendChild(navigation)
}

const createPagination = (carousel: HTMLElement) => {
    const pagination: HTMLElement = document.createElement('nav')
    pagination.classList.add('swiper-pagination')
    carousel.appendChild(pagination)
}

// Creates a wrapper around the swiper-wrapper to allow for additional styling or decoration
const createDecorationWrapper = (carousel: HTMLElement) => {
    const swiperWrapper = carousel.querySelector<HTMLDivElement>('.swiper-wrapper')
    if (!swiperWrapper) return
    const wrapper = document.createElement('div')
    wrapper.classList.add('swiper-wrapper-container')
    wrapper.appendChild(swiperWrapper)
    carousel.appendChild(wrapper)
}

const createCarousel = (query: string, swiperOptions: SwiperOptions) => {
    const carousels = document.querySelectorAll<HTMLElement>(query)
    carousels.forEach((carousel) => {
        carousel.classList.add('swiper')
        
        const children = [...carousel.children]
        children.forEach((child: HTMLElement) => {
            child.classList.add('swiper-slide')
        })

        if (swiperOptions.navigation !== false) {
            createNavigation(carousel)
            swiperOptions.navigation = {
                prevEl: '.swiper-navigation__button-prev',
                nextEl: '.swiper-navigation__button-next',
                lockClass: 'swiper-navigation__button--lock',
            }
        }

        if (swiperOptions.pagination !== false) {
            createPagination(carousel)
            swiperOptions.pagination = {
                el: '.swiper-pagination',
                clickable: true,
                bulletElement: 'button',
            }
        }

        const swiper = new Swiper(carousel, {
            modules: [ Navigation, Pagination, Autoplay ],
            createElements: true,
            watchOverflow: true,
            watchSlidesProgress: true,
            ...swiperOptions,
        })

        createDecorationWrapper(carousel)
    })
}

const createScrollingCtaCarousel = () => {
    createCarousel('.banner-scrolling-cta', {
        navigation: false,
        pagination: false,
        loop: true,
        grabCursor: true,
        autoplay: false,
    })
}

const createQuotesCarousel = () => {
    const banners = document.querySelectorAll('.banner-quotes__wrapper')
    banners.forEach((banner) => {
        const heading = banner.querySelector('.banner-pool-widget__heading')
        if (!heading) return
        const div = document.createElement('div')
        div.classList.add('banner-pool-widget__heading')
        div.innerHTML = heading.innerHTML
        heading.replaceWith(div)
        
        const link = div.querySelector('a')
        if (!link) return
        const containerCta = document.createElement('div')
        containerCta.classList.add('banner-pool-widget__container-cta')
        link.remove()
        containerCta.appendChild(link)
        banner.appendChild(containerCta)

    })

    createCarousel('.banner-quotes', {
        navigation: true,
        pagination: false,
        loop: true,
        autoHeight: false,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 25,
        speed: 750,
        autoplay: false,
        breakpoints: {
            420: {
                slidesPerView: 1.1,
            },
            991: {
                slidesPerView: 1.2,
            }
        }
    })
}

export const initialise = () => {
    createScrollingCtaCarousel()
    createQuotesCarousel()
}